<template>
  <div class="package_list">
    <title-bar-back :title="'我的卡包'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div
      v-for="(item, index) in queryCardVoucherUserPackage"
      :key="index"
      :class="{ item_list_top: index === 0 }"
      class="list_item"
      @click="goCardList(item.id, item.name)"
    >
      <!-- <img :src="packageListBg[index].bgImg" alt="" class="bg_img" /> -->
      <img :src="item.baseImg" alt="" class="bg_img" />
      <div class="card_item">
        <div class="font12 font_weight500 line_height_17 text_right item_name">
          {{ item.firstWords }}
        </div>
        <div class="font18 font_weight500 line_height_25 text_right item_title">
          {{ item.secondWords }}
        </div>
        <div
          class="font18 font_weight500 line_height_25 text_right colof item_num"
        >
          {{ item.name }} × {{ item.num }}
        </div>
      </div>
    </div>
    <div class="font12 font_weight400 colo087 bottom_all" @click="lookUseList">
      <span class="look">查看使用记录</span>
      <img src="@/assets/common/icon_right_go@2x.png" alt="" class="go_right" />
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "CardPackageList",
  components: {
    TitleBarBack
  },
  data() {
    return {
      packageListBg: [
        { bgImg: require("@/assets/mine/bg_week@2x.png") },
        { bgImg: require("@/assets/mine/bg_mounth@2x.png") },
        { bgImg: require("@/assets/mine/bg_jidu@2x.png") },
        { bgImg: require("@/assets/mine/bg_year@2x.png") }
      ]
    };
  },
  computed: {
    queryCardVoucherUserPackage() {
      return this.$store.getters.queryCardVoucherUserPackage;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.push("/mine");
    },
    getData() {
      // const params = {
      //   pageNo: pageNo,
      //   pageSize: 20
      // };
      // queryCardVoucherUserPackage
      this.$store
        .dispatch("mine/queryCardVoucherUserPackage")
        .then(() => {})
        .catch(() => {});
    },
    lookUseList() {
      this.$router.push("/mine/uselist");
    },
    goCardList(packageId, cardName) {
      // packageId
      this.$router.push({
        path: "/mine/cardvoucher",
        query: {
          packageId: packageId,
          cardName
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.package_list {
  // background: #fff;
  font-size: 0;
  .item_list_top {
    margin-top: 12px;
  }
  .list_item {
    position: relative;
    // margin: 12px 15px 0;
    // margin-top: 12px;
    .bg_img {
      width: 100%;
      max-height: 140px;
    }
    .card_item {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding-right: 39px;
      .item_name {
        color: #fef6a6;
        margin-top: 23px;
      }
      .item_title {
        color: #fef6a6;
        margin-top: 2px;
      }
      .item_num {
        margin-top: 25px;
      }
    }
  }
  .bottom_all {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    background: #fff;
    height: 48px;
    .look {
      line-height: 24px;
      vertical-align: middle;
      display: inline-block;
      margin-top: 14px;
    }
    .go_right {
      vertical-align: middle;
      margin-top: 10px;
      width: 24px;
    }
  }
}
</style>
